module.exports = __webpack_public_path__ + "static/media/totalRequest.9d3eac2b.svg";